var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.showUpcoming
      ? _c("div", { staticClass: "zw-payment-collection" }, [
          _c(
            "div",
            {
              staticClass: "ui zw-payment segment",
              class: { loading: _vm.showLoader },
              on: {
                click: function($event) {
                  return _vm.loadPaymentInfo()
                }
              }
            },
            [
              _c("div", { staticClass: "status" }, [
                _c("a", { staticClass: "ui yellow empty circular label" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "date" }, [
                _c("div", { staticClass: "ui mini statistic" }, [
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.getSubscriptionDate) +
                        "\n\t\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.getSubscriptionMonth) +
                        "\n\t\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.getSubscriptionYear) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "merchant" }, [
                _c(
                  "h3",
                  { staticClass: "ui header" },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.subscription.product.name) +
                        "\n            "
                    ),
                    _vm.subscription.status === "delayed"
                      ? [
                          _vm._v("\n              ("),
                          _c("span", { staticClass: "delayed" }, [
                            _vm._v(_vm._s(_vm.$t("globals.status.delayed")))
                          ]),
                          _vm._v(")\n            ")
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "sub header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "components.transaction.paymentstatus.upcoming"
                            )
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ])
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "amount" }, [
                _c(
                  "h3",
                  { staticClass: "ui header" },
                  [
                    _vm.subscription.pricing_is_pending_meter
                      ? [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.formatPrice(
                                  _vm.subscription.pricing_amount,
                                  2
                                )
                              ) +
                              " / m"
                          ),
                          _c("sup", [_vm._v("3")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "sub header",
                              staticStyle: {
                                "font-size": "0.8em",
                                color: "#999",
                                "margin-top": "0.5em"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "components.transaction.info.pending_meter_notice"
                                    ) || "Final price based on water usage"
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      : [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.formatPrice(_vm.displayPricingAmount, 2)
                              ) +
                              "\n\t\t\t\t\t\t"
                          )
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "sub header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.getCurrency) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.waterPeriodPrice && _vm.waterPeriodPrice.period
                      ? _c("div", { staticClass: "sub header" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.waterPeriodPrice.period.start_date) +
                              " — " +
                              _vm._s(_vm.waterPeriodPrice.period.end_date) +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showPaymentInfo
            ? _c("div", { staticClass: "ui padded segment zw-payment-info" }, [
                _c("div", { staticClass: "ui two column stackable grid" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("h3", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("components.transaction.info.paymentinfo")
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "list" }, [
                        _c("div", { staticClass: "item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("components.transaction.info.to_be_paid", {
                                date: _vm.getDateString
                              })
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item" })
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.selectedAccessories.length > 0
                      ? _c("div", { staticClass: "ui header" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "components.transaction.info.accessories"
                                )
                              ) +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedAccessories.length > 0
                      ? _c(
                          "div",
                          { staticClass: "content" },
                          _vm._l(_vm.selectedAccessories, function(accessory) {
                            return _c(
                              "div",
                              {
                                key: accessory.id,
                                staticClass: "ui green label"
                              },
                              [_vm._v(_vm._s(accessory.name))]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("h3", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("components.transaction.info.merchantinfo")
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "ui list" }, [
                        _c("div", { staticClass: "item" }, [
                          _vm._v(_vm._s(_vm.activeMerchant.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "telto:" + _vm.activeMerchant.phone
                              }
                            },
                            [_vm._v(_vm._s(_vm.activeMerchant.phone))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "mailto:" + _vm.activeMerchant.email
                              }
                            },
                            [_vm._v(_vm._s(_vm.activeMerchant.email))]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("components.transaction.info.purchase")
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _vm.subscription.pricing_is_pending_meter
                          ? [
                              _c("div", { staticClass: "ui two column grid" }, [
                                _c(
                                  "div",
                                  { staticClass: "left aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.transaction.info.water_rate"
                                          ) || "Water Rate (per m³)"
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "right aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formatPrice(
                                            _vm.subscription.pricing_amount,
                                            2
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.getCurrency) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "ui two column grid" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "left aligned column",
                                    staticStyle: {
                                      color: "#999",
                                      "font-size": "0.85em"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.transaction.info.pending_meter_notice"
                                          ) ||
                                            "This is the rate per cubic meter. Final charge will be based on water usage."
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.selectedAccessories.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "ui two column grid" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "left aligned column",
                                          staticStyle: {
                                            color: "#999",
                                            "font-size": "0.85em"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.transaction.info.accessories_included"
                                                ) ||
                                                  "Accessories included in above rate"
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm.waterPeriodPrice
                          ? _vm._l(_vm.waterPeriodItems, function(item, index) {
                              return _c("div", { key: index }, [
                                _c(
                                  "div",
                                  { staticClass: "ui two column grid" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "left aligned column" },
                                      [
                                        _vm._v(
                                          "\n\t                      " +
                                            _vm._s(item.name) +
                                            "\n\t                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "right aligned column" },
                                      [
                                        _vm._v(
                                          "\n\t                      " +
                                            _vm._s(
                                              _vm.getWaterPeriodItemNetPrice(
                                                item
                                              )
                                            ) +
                                            " " +
                                            _vm._s(_vm.getCurrency) +
                                            "\n\t                    "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                item.vat
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "ui two column grid",
                                        staticStyle: { "margin-top": "-2rem" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "left aligned column"
                                          },
                                          [
                                            _vm._v(
                                              "\n\t                      25,00% moms:\n\t                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "right aligned column"
                                          },
                                          [
                                            _vm._v(
                                              "\n\t                      " +
                                                _vm._s(
                                                  _vm.getWaterPeriodItemVat(
                                                    item
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(_vm.getCurrency) +
                                                "\n\t                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            })
                          : [
                              _c("div", { staticClass: "ui two column grid" }, [
                                _c(
                                  "div",
                                  { staticClass: "left aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.subscription.product.name) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "right aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getProductPriceFromTotalPrice(
                                            _vm.subscription,
                                            _vm.subscription.pricing_amount
                                          )
                                        ) +
                                        "\n                    " +
                                        _vm._s(_vm.getCurrency) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.subscription.product.apply_vat
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "ui two column grid",
                                      staticStyle: { "margin-top": "-2rem" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "left aligned column" },
                                        [
                                          _vm._v(
                                            "\n                    25,00% moms:\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "right aligned column" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getProductPriceVatFromTotalPrice(
                                                  _vm.subscription,
                                                  _vm.subscription
                                                    .pricing_amount
                                                )
                                              ) +
                                              " " +
                                              _vm._s(_vm.getCurrency) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedAccessories.length > 0
                                ? _vm._l(_vm.selectedAccessories, function(
                                    accessory
                                  ) {
                                    return _c("div", { key: accessory.id }, [
                                      _c(
                                        "div",
                                        { staticClass: "ui two column grid" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "left aligned column"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(accessory.name) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "right aligned column"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.getAccessoryPrice(
                                                      accessory
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(_vm.getCurrency) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      accessory.apply_vat
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "ui two column grid",
                                              staticStyle: {
                                                "margin-top": "-2rem"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "left aligned column"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        25,00% moms:\n                      "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "right aligned column"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.getAccessoryPriceVat(
                                                          accessory
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(_vm.getCurrency) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  })
                                : _vm._e()
                            ],
                        _vm._v(" "),
                        _vm.subscription.expire_date
                          ? _c("div", { staticClass: "ui two column grid" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "left aligned column",
                                  staticStyle: { color: "green" }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.transaction.info.expire_date"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "right aligned column",
                                  staticStyle: { color: "green" }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.getExpireDate) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "ui two column grid" }, [
                          _c("div", {
                            staticClass: "two wide left aligned column"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "fourteen wide column" }, [
                            false
                              ? _c(
                                  "table",
                                  {
                                    staticClass:
                                      "ui very basic borderless compact table"
                                  },
                                  [
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.selectedAccessories,
                                          function(accessory) {
                                            return _c(
                                              "tr",
                                              { key: accessory.id },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "left aligned"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(accessory.name)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "right aligned"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatPrice(
                                                          accessory.pricing
                                                            .price
                                                        )
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          accessory.pricing
                                                            .currency
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { staticClass: "left aligned" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.subscription.product.name
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "right aligned" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPrice(
                                                    _vm.subscription.pricing
                                                      .price
                                                  )
                                                ) +
                                                  " " +
                                                  _vm._s(_vm.getCurrency)
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "ui divider" }),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass:
                                  "ui very basic borderless compact table"
                              },
                              [
                                _c("tbody", [
                                  _vm.hasKamstrupMeterUsage
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "left aligned" },
                                          [_vm._v("Vandforbrug")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "right aligned" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.kamstrupMeterReadingTotal
                                              ) + " m"
                                            ),
                                            _c("sup", [_vm._v("3")])
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("td", { staticClass: "left aligned" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "components.transaction.info.total"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "right aligned" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatPrice(
                                            _vm.displayPricingAmount
                                          )
                                        ) +
                                          " " +
                                          _vm._s(_vm.getCurrency)
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ])
                        ])
                      ],
                      2
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70ac1019", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ac1019","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/UpcomingTransaction.vue
// module id = XJ+H
// module chunks = 1